import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

interface ActionButtonsProps {
  CancelButtonText?: string;
  CancelButtonUrl?: string;
  DeleteButtonText?: string;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  HandleDelete?: (() => void) | ((event: any) => void);
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  HandleSave?: (() => void) | ((event: any) => void);
  HideSaveButton?: boolean;
  HideCancelButton?: boolean;
  SaveButtonText?: string;
}

const ActionButtons = ({
  CancelButtonText = 'Peruuta',
  CancelButtonUrl,
  DeleteButtonText = 'Poista',
  HandleDelete,
  HandleSave,
  HideSaveButton,
  SaveButtonText = 'Tallenna',
  HideCancelButton,
}: ActionButtonsProps) => {
  const navigate = useNavigate();

  const handleCancelClick = () => {
    navigate(CancelButtonUrl);
  };

  return (
    <div className="border-top my-48 pt-48">
      {HideSaveButton ||
        (HandleSave !== null && (
          <Button
            className="mb-16 w-100"
            variant="primary"
            onClick={HandleSave}
          >
            {SaveButtonText}
          </Button>
        ))}
      {DeleteButtonText !== '' && HandleDelete !== null && (
        <Button className="mb-16 w-100" variant="danger" onClick={HandleDelete}>
          {DeleteButtonText}
        </Button>
      )}
      {!HideCancelButton && CancelButtonUrl !== '' && (
        <Button
          className="w-100"
          variant="link"
          onClick={() => handleCancelClick()}
        >
          {CancelButtonText}
        </Button>
      )}
    </div>
  );
};

// ActionButtons.defaultProps = {
//   CancelButtonText: 'Peruuta',
//   CancelButtonUrl: '',
//   DeleteButtonText: '',
//   HandleDelete: null,
//   HandleSave: null,
//   HideSaveButton: false,
//   SaveButtonText: 'Tallenna',
// };

export default ActionButtons;
export { ActionButtons };
export type { ActionButtonsProps };
